
<template>
    <card-seplag titulo="Permissões de relatórios">
        <div class="p-col-12">
            <div class="p-grid p-fluid">
                <Rotulo nome="Perfil " cols="12 4">
                    <Dropdown class="classe-dropdown" v-model="perfilSelecionado" :options="dropdownPerfilAcesso" filter
                        optionLabel="nomePerfilAcesso" placeholder="Selecione um Perfil " />
                </Rotulo>
                <Rotulo cols="12 4">
                    <Button label="Selecionar" icon="" class="classe-buttom" @click="SelecionarPerfil()" />
                </Rotulo>
            </div>
            <div class="p-grid p-fluid">
                <Panel header="Selecione as autorizações para o perfil selecionado:" class="p-col-12">
                    <div class="p-grid p-fluid">
                        <Rotulo nome="Relatórios:" cols="12">
                            <!-- <DataTable :value="dadosAutorizacoes" :selection.sync="autorizacaoSelecionada">
                                <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
                                <Column header="Nome de Exibição ">
                                    <template #body="slotProps"
                                        :disabled="slotProps.data.nomeRole == 'RELATORIO_DADOS_DEPENDENTES_VIEW'">
                                        <div>
                                            <span>{{slotProps.data.data.nomeExibir }}</span>
                                        </div>
                                    </template>
                                </Column>
                                <Column header=" Nome" field="data.nomeExibir"></Column>
                                <Column header="Descrição" field="data.descricaoAutorizacao">
                                </Column>
                                <Column header="Nível de Acesso" field="nivelAcesso">
                                </Column>
                            </DataTable> -->

                            <DataTable :value="dadosAutorizacoes">
                                <Column header="" headerStyle="width:7%;" :bodyStyle='"text-align: center;"'>
                                    <template #body="slotProps">
                                        <Checkbox :id="slotProps.data.id" :inputId="slotProps.data.id"
                                            name="data.nomeExibir" :value="slotProps.data" v-model="autorizacaoSelecionada"  :disabled="slotProps.data.nomeRole == 'RELATORIO_DADOS_DEPENDENTES_VIEW' || slotProps.data.nomeRole == 'RELATORIO_DADOS_CAPACITACAO_VIEW'"/>
                                    </template>
                                </Column>
                                <Column header="Nome de exibição ">
                                    <template #body="slotProps">
                                        <div>
                                            <span>{{slotProps.data.data.nomeExibir }}</span>
                                        </div>
                                    </template>
                                </Column>
                                <Column header="Descrição" field="data.descricaoAutorizacao">
                                </Column>
                                <Column header="Nível de acesso" field="nivelAcesso">
                                </Column>
                            </DataTable>
                        </Rotulo>
                        <Rotulo cols="12 8" />
                        <Rotulo cols="12 4">
                            <Button label="Salvar" icon="pi pi-check" class="p-button-success "
                                @click="salvarAutorizacaoRelatorio()" v-if="perfilSelecionado !== null" />
                        </Rotulo>
                    </div>
                </Panel>
            </div>

            <Dialog :visible.sync="exibirModalFaleConosco" header="Fale Conosco" :modal="true"
                :contentStyle="'max-width:80rem;'">
                <div>
                    <div class="p-grid p-fluid">
                    </div>
                    <div class="p-col-12">
                        <DataTable :value="faleConoscoTable">
                            <Column header="Seleção" headerStyle="width:7%;" :bodyStyle='"text-align: center;"'>
                                <template #body="slotProps">
                                    <Checkbox :id="slotProps.data.idenAssunto" :inputId="slotProps.data.idenAssunto"
                                        :value="slotProps.data.idenAssunto" v-model="faleSelecionadoSelecionado" />
                                </template>
                            </Column>
                            <Column header="Nome Assunto" field="nomeAssunto">
                            </Column>
                            <Column header="Descrição" field="descAssunto">
                            </Column>
                            <Column header="Status" field="statAssunto">
                            </Column>
                            <Column headerStyle="width: 6em" bodyStyle="text-align: center">
                                <template #body="el">
                                    <Button type="button" icon="pi pi-download" class="p-button-success"
                                        style="margin-right: .5em"> Visualizar</Button>
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                    <div class="p-grid p-fluid">
                        <div class="p-col-8">
                        </div>
                        <div class="p-col-4">
                            <Button label="Salvar" icon="pi pi-save" class="p-button-success"
                                @click="salvarFaleConosco()" />
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'
import DataTable from 'primevue/datatable/DataTable'

export default {
    components: { CardSeplag, Rotulo, DataTable },
    name: 'GESTAOPESSOA_PERMISSOES_VIEW',
    data: function () {
        return {
            dropdownPerfilAcesso: null,
            filtroTodos: {
                "idenPerfilAcesso": 0,
                "nomePerfilAcesso": 'TODOS'
            },
            exibirModalFaleConosco: null,
            filtro: {
                textoPesquisa: null,
                idenPerfilAcesso: null,
                idenPessoaUsuario: null,
                orgaoEmpresaUsuario: [],
                nome: null,
                idenFalesConosco: null,
                nivelAcesso: null,
                filtroVisu: null,
                dados: []

            },
            perfilSelecionado: null,
            faleConoscoTable: [],
            faleSelecionadoSelecionado: [],
            dadosAutorizacoes: [],
            autorizacoes: [],
            autorizacaoSelecionada: [],
        }
    },
    methods: {
        async carregarDados() {
            this.listarPerfisAcesso();
            this.listarAutorizacoes();
        },
        listarPerfisAcesso() {
            this.$http.get(`${baseApiUrl}/seguranca/perfilacessos/`).then(res => {
                this.dropdownPerfilAcesso = res.data
                if (res.data.length > 0) {
                    this.perfilSelecionado = res.data[0];
                    this.SelecionarPerfil();
                }
            })
        },
        ModalFaleConosco() {
            this.exibirModalFaleConosco = true;
        },
        SelecionarPerfil() {
            this.autorizacaoSelecionada = this.perfilSelecionado.autorizacoes
            this.nomeSelecionado = this.filtro.nome
        },
        listarAutorizacoes() {
            this.$http.get(`${baseApiUrl}/seguranca/autorizacaos/listaAutorizacaoRelatorio`).then(res => {
                this.dadosAutorizacoes = res.data
                // .filter(element => element.nomeRole != "RELATORIO_DADOS_DEPENDENTES_VIEW" && element.nomeRole != "RELATORIO_DADOS_CAPACITACAO_VIEW" )
                // relatorios com problema( estão tirando a permissão de acesso)
            })
        },
        salvarAutorizacaoRelatorio() {
            let body = this.autorizacaoSelecionada
            this.$http.put(`${baseApiUrl}/seguranca/perfilacessos/v2/controleAutorizacaoRelatorio/${this.perfilSelecionado.id}`, JSON.stringify(body)).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Ação efetuada', detail: "Autorizações vinculadas com sucesso!", life: 5000 });
                this.$http.get(`${baseApiUrl}/seguranca/perfilacessos/`).then(res => {
                    this.dropdownPerfilAcesso = res.data
                })
            })
        },
    },
    mounted() {
        this.carregarDados()
    }
}
</script>



<style scoped>
.classe-buttom {
    max-height: 40px;
    margin-top: 16px;
}

h4 {
    text-align: center;
}
</style>
